export default "__VITE_ASSET__BZN4zd$q__"